import { Link } from "react-router-dom";
import { allTopics, getNewsByTopic } from "@/utils/news";

export default function TopicSpotlight() {
  return (
    <section className="mx-auto w-full max-w-shell px-4 py-12 md:px-6 md:py-16">
      <div className="mb-8">
        <span className="font-label text-xs tracking-[0.3em] text-primary-700">
          IN-DEPTH
        </span>
        <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          深度分析专题推荐
        </h2>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
          围绕重点事件持续追踪，把碎片化的爆料串联成完整的时间线与证据链。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        {allTopics.map((topic) => (
          <Link
            key={topic.id}
            to={`/topic/${topic.id}`}
            className="group relative overflow-hidden rounded-lg border border-background-200"
          >
            <div className="relative h-56 w-full">
              <img
                src={topic.cover}
                alt={topic.name}
                title={`${topic.name} - 911爆料专题`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/60 to-transparent" />
            </div>

            <div className="absolute inset-x-0 bottom-0 p-5">
              <div className="flex items-center gap-2">
                <span className="rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-bold text-background-50">
                  专题
                </span>
                <span className="text-xs text-foreground-600">
                  {getNewsByTopic(topic.id).length} 篇深度报道
                </span>
              </div>
              <h3 className="mt-2 font-heading text-xl font-bold text-foreground-950">
                {topic.name}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                {topic.summary}
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-700">
                查看专题
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}